module.exports = __webpack_public_path__ + "static/building-footer-cf78f87830181d540811cd21ca0605fe.png";